import { Outlet, useParams } from 'react-router-dom'
import { useContext, useEffect } from 'react'
import useAlertTeacherOffline from '../../remoteView/v2/useAlertTeacherOffline'
import useBlockedTabs from '../../remoteView/v2/useBlockedTabs'
import useSendScreenshots from '../../remoteView/v2/useSendScreenshots'
import useShowIndicatorGroup from '../../remoteView/v2/useShowIndicatorGroup'
import { useGroupStudentsIds } from '../../api/queries/groups/useGroupUsers'
import { remoteViewContext } from '../../remoteView/v2/RemoteViewProvider'
import { useDispatch } from 'react-redux'
import { clearOnlineStudents } from './redux/onlineStudentReducer'
import useWebsocketLoggedIn from '../../remoteView/v2/useWebsocketLoggedIn'

const GroupSubscribe = () => {
  const alertTeacherOffline = useAlertTeacherOffline()
  const { resetBlockedTabs } = useBlockedTabs()
  const { resetSendScreenshots } = useSendScreenshots()
  const { resetShowIndicatorGroup } = useShowIndicatorGroup()
  const { groupId } = useParams()
  const { studentIds } = useGroupStudentsIds(groupId)
  const { studentMonitor } = useContext(remoteViewContext)
  const { loggedIn } = useWebsocketLoggedIn()
  const dispatch = useDispatch()

  useEffect(() => {
    if (loggedIn && studentIds?.length > 0) {
      studentMonitor?.subscribe(studentIds)
    }
  }, [loggedIn, studentIds, studentMonitor])

  // alert students on unmount
  useEffect(
    () => () => {
      alertTeacherOffline()
      resetBlockedTabs()
      resetSendScreenshots()
      resetShowIndicatorGroup()
      dispatch(clearOnlineStudents())
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  // render page
  return <Outlet />
}

export default GroupSubscribe
